// Added JavaScript proceeding theme.js (that doesn't require any liquid or any vars from the .js.liquid theme file)
// Allows for easier editing/highlighting when can be pure JS
const AGE_ENTRY = '_bod_age_entry';
const AGE_ENTRY_ACCEPTED = 'accepted';
const AGE_ENTRY_DAYS_VALID = 100;
const COOKIE_DOMAIN = 'bodriggy.beer';
$(function () {
  var ageEntryCookie = readCookie(AGE_ENTRY);
  var ageAccepted = (ageEntryCookie === AGE_ENTRY_ACCEPTED);

  function createCookie(name,value,days) {
    if (days) {
    	var date = new Date();
    	date.setTime(date.getTime()+(days*24*60*60*1000));
    	var expires = "; expires=" + date.toGMTString();
    } else {
      var expires = "";
    }
    var cookieString = name+"="+value+expires+"; path=/"+"; domain=" + COOKIE_DOMAIN;
    document.cookie = cookieString;
  }
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i=0;i < ca.length;i++) {
    	var c = ca[i];
    	while (c.charAt(0)==' ') {
        c = c.substring(1,c.length);
      }
    	if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length,c.length);
      }
    }
    return null;
  }
  function promptAgeEntry() {
    $('.bod-ag-container').removeClass('bod-ag-container--closed');
    $('.bod-page-gate').removeClass('bod-page-gate--closed');
    completePageLoad();
  }
  function completePageLoad() {
    $('.bod-page').removeClass('bod-page--loading');
  }
  function acceptAgeEntry() {
    $('.bod-ag-button--dob').addClass('bod-ag-button--dob-accepted');
    createCookie(AGE_ENTRY, AGE_ENTRY_ACCEPTED, AGE_ENTRY_DAYS_VALID);

    $('.bod-ag-container').addClass('bod-ag-container--closed');
    $('.bod-page-gate').addClass('bod-page-gate--closed');
  }
  if (!ageAccepted) {
    promptAgeEntry();
  } else {
    completePageLoad();
  }
  // Age gate overlay - site wide
  $('body').on('click', '.js-ag-dob-enter', function(e) {
    e.preventDefault();
    acceptAgeEntry();
  });

  //  Class added to page when scrolled
  //    - Used so that back to top button appears when scrolled
  $(window).scroll(function() {
    var s = $(".bod-body");
    var pos = s.position();

    if (s.length) {
      var windowpos = $(window).scrollTop();
      if (windowpos >= pos.top & windowpos <=0) {
        s.removeClass("bod-body--scrolled");
      } else {
        s.addClass("bod-body--scrolled");
      }
    }
  });

  //  Class added to page when reaching bottom of page
  $(window).scroll(function() {
     $(".bod-body").removeClass("bod-body--bottom");
     if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100) ) {
         // At bottom
         $(".bod-body").addClass("bod-body--bottom");
     }
  });

  //  Back to top button
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".bod-body").offset().top
    }, 800);
    e.preventDefault();
  });
  
  // Menu toggle
  $('body').on('click', '#bod-menu-toggle', function(e) {
    e.preventDefault();
    $(".bod-main-menu-container").toggleClass("bod-main-menu-container--open");
    $(".bod-page").toggleClass("bod-page--menu-is-open");
    $(".bod-header-container").toggleClass("bod-header-container--menu-is-open");
    $(".bod-header-container").toggleClass("bod-header-container--scrollbar");
  });

  // Socials toggle
  $('body').on('click', '.bod-socials-toggle', function(e) {
    e.preventDefault();
    $(".bod-main-menu-container-inner").toggleClass("bod-main-menu-container-inner--show-socials");
  });

  // Whats on fillter toggle mobile
  $('body').on('click', '.bod-filter-toggle', function(e) {
    e.preventDefault();
    $(".bod-event-filter-list").toggleClass("bod-event-filter-list--open");
  });
});
